import React, { useState } from 'react';
import { ShieldCheck, ShieldAlert, ShieldQuestion } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "../ui/dialog";
import { IdentityForm } from "./ChildIdentity";

export const CurpBadge = ({ account, onUpdated }) => {
  const [open, setOpen] = useState(false);

  if (account.curp_status === "verified") {
    return <span data-testid={`curp-badge-${account.id}`} className="inline-flex items-center gap-1 text-[11px] font-bold bg-brand-green/90 text-brand-dark px-2 py-1 rounded-full"><ShieldCheck className="w-3 h-3" /> CURP verificado</span>;
  }
  if (account.curp_status === "format_valid") {
    return (
      <span data-testid={`curp-badge-${account.id}`} title={account.curp_masked || ""} className="inline-flex items-center gap-1 text-[11px] font-bold bg-white/20 text-white px-2 py-1 rounded-full">
        <ShieldQuestion className="w-3 h-3" /> CURP {account.curp_masked} · RENAPO pendiente
      </span>
    );
  }
  return (
    <>
      <button data-testid={`curp-missing-btn-${account.id}`} onClick={() => setOpen(true)} className="inline-flex items-center gap-1 text-[11px] font-bold bg-amber-300 text-brand-dark px-2 py-1 rounded-full hover:bg-amber-200 transition-colors">
        <ShieldAlert className="w-3 h-3" /> Completar datos del menor
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="identity-dialog">
          <DialogHeader>
            <DialogTitle>Vincular alcancía a {account.child_name}</DialogTitle>
            <DialogDescription>Confirma el nombre completo, fecha de nacimiento y CURP del menor bajo tu custodia.</DialogDescription>
          </DialogHeader>
          <IdentityForm account={account} onSaved={() => { setOpen(false); onUpdated(); }} />
        </DialogContent>
      </Dialog>
    </>
  );
};
